import {ActiveUserService, CEProtocol, CEConstructor, ListSpecType} from 'lionheartland';
import {HttpClient} from 'lionheartland';
import {EONotificationService} from '../../core/notification/eo-notification';
import {SOGetNotification} from '../../core/notification/so-get-notification';
import {RAPutNotification} from './ra-put-notification';
import {RAPostNotification} from './ra-post-notification';
import {RADeleteNotification} from './ra-delete-notification';
import {AbstractEntityCore} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {SOGetOrganization} from '../../core/organization/so-get-organization'
import { CENotification } from "./ce-notification"


export class NotificationCoreBase extends AbstractEntityCore implements EntityCoreProtocol {

  type = 'notification';
  title = 'Notification';
  ceProtocol: CEConstructor = CENotification

  entityService: EONotificationService;
  soGetClass = SOGetNotification;
  soGet: SOGetNotification;


  constructor(
    public activeUserService: ActiveUserService,
  ) {
    super(
      activeUserService,
      EONotificationService,
      null,
    );
    this.adapters = [
      new RAPostNotification(this),
      new RAPutNotification(this),
      new RADeleteNotification(this),
    ];
    this.resetSoGet()
    this.setDefaultAdapters();
    this.finalInit();
  }

  resetSoGet() {
    this.soGet = new SOGetNotification();
    if (this.activeUserService.getScope('organization')) {
        this.soGet.organization = new SOGetOrganization(
          this.activeUserService.getScope('organization').uid
        );
    }
    this.soGet.queryOptions.limit = this.limit;
  }


}